


















































import { defineComponent, ref, onUpdated, onMounted, onBeforeUnmount, computed, watch } from '@vue/composition-api';
import { useStore } from '@/store';
import { ActionTypes } from '@/store/actions';
import { SelectScroller } from '@/util/SelectScroller';

interface PropsInterface {
    index: number;
    id: number;
}

declare const getmdlSelect: { init: (string) => void };
declare const componentHandler: { upgradeDom: () => void };

const VISIBLE_VEHICLES_AMOUNT = 5;

export default defineComponent({
    name: 'VehiclesSelect',
    components: {},
    props: {
        index: { type: Number, required: true },
        id: { type: Number, required: true }
    },
    setup (props: PropsInterface, { refs, root }) {
        const store = useStore();
        const shortlistItems = computed(() => store.state.shortInfo);
        const comparingItems = computed(() => store.state.tickedItems);

        const controlId = ref('vehicle-select-' + props.index);
        const selectId = ref('getmdl-select-' + props.index);

        const getCaption = () => {
            if (props.id) {
                const vehicle = shortlistItems.value.find(v => v.id === props.id);
                if (vehicle) {
                    return vehicle.caption;
                }
            }
            return 'Select Vehicle';
        };

        const selectValue = ref(getCaption());

        const mdChanged = (event: Event, index: number) => {
            const id = +((event.target as HTMLInputElement).nextElementSibling as HTMLInputElement).value;
            if (id && id !== props.id) {
                store.dispatch(ActionTypes.ItemSelected, {
                    index: index,
                    id: id
                });
            }
        };

        const disableSelection = function () {
            this.selectionStart = this.selectionEnd;
        };

        let scroller;
        onMounted(() => {
            root.$nextTick(() => {
                componentHandler.upgradeDom();
                getmdlSelect.init('#' + selectId.value);
            });
            (refs.mdlInput as HTMLInputElement).addEventListener('select', disableSelection);

            scroller = new SelectScroller(refs.scrollable as Node);
            watch(shortlistItems, (newValue) => {
                if (newValue.length > VISIBLE_VEHICLES_AMOUNT) {
                    scroller.observe();
                } else {
                    scroller.destroy();
                }
            }, { immediate: true });
        });

        onBeforeUnmount(() => {
            (refs.mdlInput as HTMLInputElement).removeEventListener('select', disableSelection);
            scroller && scroller.destroy();
        });

        onUpdated(() => {
            selectValue.value = getCaption();
        });

        return {
            selectValue,
            controlId,
            selectId,
            mdChanged,
            shortlistItems,
            comparingItems
        };
    }
});
